import { Link } from "react-router-dom";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container-max section-padding pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-montserrat font-bold text-primary mb-4">GoPhoenix</h3>
            <p className="text-secondary-foreground/70 font-roboto text-sm leading-relaxed mb-4">
              GoPhoenix Data Solutions FZ LLC is a future-ready technology and digital marketing company delivering scalable software, data-driven platforms, and performance-oriented digital growth solutions.
            </p>
            <div className="flex gap-3">
              {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-montserrat font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Software Solutions", path: "/software-solutions" },
                { name: "Digital Marketing", path: "/digital-marketing" },
                { name: "Industries", path: "/industries" },
                { name: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-roboto">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-montserrat font-bold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2">
              {[
                { name: "Web & App Development", path: "/services/web-app-development" },
                { name: "AI, Data & Automation", path: "/services/ai-data-automation" },
                { name: "SEO & Performance Marketing", path: "/services/seo-performance-marketing" },
                { name: "Branding & Creative", path: "/services/branding-creative" },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-secondary-foreground/70 hover:text-primary transition-colors text-sm font-roboto">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-montserrat font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FiMapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-secondary-foreground/70 text-sm font-roboto">
                  CWEP1641, Compass Building, Al Shohada Road, AL Hamra Industrial Zone-FZ, Ras Al Khaimah, UAE
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FiMail className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="mailto:gophoenixdatasolutions@gmail.com" className="text-secondary-foreground/70 hover:text-primary text-sm font-roboto transition-colors">
                  gophoenixdatasolutions@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <FiPhone className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="tel:+971585791239" className="text-secondary-foreground/70 hover:text-primary text-sm font-roboto transition-colors">
                  +971 58 579 1239
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-secondary-foreground/10">
        <div className="container-max px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-secondary-foreground/50 text-sm font-roboto">
            © {new Date().getFullYear()} GoPhoenix Data Solutions FZ LLC. All rights reserved.
          </p>
          <p className="text-secondary-foreground/50 text-sm font-roboto">
            Data. Digital. Domination.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
